/*
 *  Product Thumbnail Print
 *    Exporting common product thumbnail string.
 *
 *
 *  Version:
 *    1.0.0 - 2019/06/17
 */
import { pictureGenerate, generateIcon, printMoney, escapeString, t } from '@process-creative/slate-theme-tools';
import { getSwatchHTML, getButtonStatus} from './../../sections/product-thumbnail/ProductThumbnail';
import { DiscountMessaging } from './../../sections/discount-messaging/DiscountMessaging';

export const CP = 'o-product-thumbnail';

export const ProductThumbnailPrint = (p, p2, url, discounted, saving, available, compare, v, position, hasColourOption, hasSizesOptions, productsShowPercentageOff, yotpoReviews) => {
  //Is on preorder?
  const isPreorder = v.inventory_management == 'shopify' && v.inventory_policy == 'continue' && v.inventory_quantity <= 0;

  let showVariants = true;
  //Find out badge smart tags.
  let badge;
  let badges = [];
  p.tags.find(tag => {
    tag = tag.toString().toLowerCase();
    if(tag.includes('badge_')) {
      badge = tag.split('_')[1];
      badges.push(badge)
    }
  });

  //Determine current variant ID to use
  let currentVariant;
  if(v) {
    currentVariant = v.id;
  } else if(p.first_available_variant.id) {
    currentVariant = p.first_available_variant.id;
  }

  //Determine which image to use
  let firstImage = p.image;
  if(v.featured_image && v.featured_image.src) firstImage = v.featured_image.src;

  let secondImage = p.second_image;
  if(!secondImage || !secondImage.length) secondImage = firstImage;
  if(v.hover_image) secondImage = v.hover_image;

  //Discount message display logic
  let discountContainer = document.createElement('p');
  discountContainer.setAttribute('class', 'o-product-thumbnail__discount o-paragraph is-small');
  discountContainer.setAttribute('data-product-thumbnail-discount', true);
  DiscountMessaging(p2.collections, discountContainer);

  let shouldPrintSwatch = false;
  if (hasSizesOptions) shouldPrintSwatch = true;

  let [ disabled, text, condition ] = getButtonStatus(v);

  if (v.waitlist_eta && !v.available) {
    return `
      <div
        class="${CP} c-collection-template__product c-collection-template__product--waitlist"

        data-product-thumbnail
        data-product-handle="${p.handle}"
        data-product-id="${p.id}"
        data-variant-id="${currentVariant}"
        data-collections=""
        position="${position}"
      >
        <div class="${CP}__container">

          <script type="application/json" data-product-json>
            ${JSON.stringify(p2)}
          </script>

          ${p.ratingValue && p.ratingCount && p.ratingCount > 0 ?
            `<script type="application/ld+json">
              ${generateProductSchema(p)}
            </script>` : ``}

          <div class="${CP}__unavailable" data-product-thumbnail-unavailable>
          </div>

          <div class="o-product-thumbnail__image-container">
            <a href="${url}" class="${CP}__image-inner">
              ${pictureGenerate({ src: secondImage,
                srcSize: 480,
                sizes: [
                  { size: 165, screen: 375 },
                  { size: 230, screen: 500 },
                  { size: 240, screen: 750 },
                  { size: 315, screen: 1000 },
                  { size: 350, screen: 1350 },
                  { size: 424, screen: 1650 },
                  { size: 480, screen: 2000 }
                ],
                class:`${CP}__image`
              }).replace('<img', '<img loading="lazy"')}
              ${pictureGenerate({ src: firstImage,
                srcSize: 480,
                sizes: [
                  { size: 165, screen: 375 },
                  { size: 230, screen: 500 },
                  { size: 240, screen: 750 },
                  { size: 315, screen: 1000 },
                  { size: 350, screen: 1350 },
                  { size: 424, screen: 1650 },
                  { size: 480, screen: 2000 }
                ],
                class:`${CP}__image ${CP}__image-top`
              }).replace('<img', '<img loading="lazy"')}

              <div class="o-product-thumbnail__badge-container">
                ${badges.reduce((x,name) => {
                  if (name.toLowerCase() === 'new' && badges.some(b => b.toLowerCase() === 'waitlist')) return x;
                  return x += `<span class="o-product-thumbnail__badge">${name}</span>`;
                }, '')}
              </div>
            </a>

            <div class="${CP}__add-container">
              <div class="${CP}__swatch-price-container">
                <div class="${CP}__swatch" data-product-swatch-selector>
                  ${shouldPrintSwatch & p.available?
                    showVariants ? getSwatchHTML(p, v) :''
                  : printMoney(v.price)
                  }
                </div>
              </div>

              <a href="${url}"
                class="o-btn o-product-thumbnail__add-button
                  c-collection-template__product-notify-link"
                data-product-thumbnail-add-to-waitlist-button
              >
              ${v.waitlist_eta?
                escapeString(Language.strings['products.product.join_waitlist']):
                escapeString(Language.strings['products.product.sold_out_notify_me'])}
              </a>
            </div>
          </div>


          <div class="${CP}__details">
            <div class="${CP}__details-wrapper">
              <a href="${url}">
                <span itemprop="name" class="${CP}__title">
                  ${p.title}
                </span>
              </a>

              <button class="${CP}__wishlist" data-product-template-wishlist role="button" title="add to wish list" ${generateWishlistAttr(p,v)}>
                ${generateIcon('heart-grey', 'o-product-thumbnail__wishlist-icon')}
                ${generateIcon('heart--full-grey', 'o-product-thumbnail__wishlist-icon is-full')}
              </button>
            </div>


            <div class="${CP}__price-container" data-product-thumbnail-price>
              ${(discounted) ? `
                <span class="${CP}__price-compare-original"
                  data-currency
                  data-money="${compare}"
                  data-product-compare-money
                >
                  ${printMoney(compare)}
                </span>

                ${productsShowPercentageOff ? `
                  <span class="${CP}__price-compare-saving">
                    ${Math.floor(saving)}% ${t('products.product.off')}
                  </span>
                `: ''}
              `
              : '' }

              <span class="${CP}__price" data-currency data-product-money data-money="${v.price}">
                ${printMoney(v.price)}
              </span>
            </div>

            <div class="o-product-thumbnail__waitlist-message">
              ${Language.strings['products.product.waitlist_message']} ${v.waitlist_eta}
            </div>


            ${discountContainer.innerHTML.length ? discountContainer.outerHTML : ''}
          </div>
        </div>
      </div>
    `;
  }


  return `
  <div
    class="${CP} c-collection-template__product"

    data-product-thumbnail
    data-product-handle="${p.handle}"
    data-product-id="${p.id}"
    data-variant-id="${currentVariant}"
    data-collections=""
    position="${position}"
  >
    <div class="${CP}__container">

      <script type="application/json" data-product-json>
        ${JSON.stringify(p2)}
      </script>

      ${p.ratingValue && p.ratingCount && p.ratingCount > 0 ?
        `<script type="application/ld+json">
          ${generateProductSchema(p)}
        </script>` : ``}

      <div class="${CP}__unavailable" data-product-thumbnail-unavailable>
      </div>

      <div class="o-product-thumbnail__image-container">
        <a href="${url}" class="${CP}__image-inner">
          ${pictureGenerate({
            src: secondImage,
            srcSize: 480,
            sizes: [
              { size: 165, screen: 375 },
              { size: 230, screen: 500 },
              { size: 240, screen: 750 },
              { size: 315, screen: 1000 },
              { size: 350, screen: 1350 },
              { size: 424, screen: 1650 },
              { size: 480, screen: 2000 }
            ],
            class:`${CP}__image`
          }).replace('<img', '<img loading="lazy"')}
          ${pictureGenerate({
            src: firstImage,
            srcSize: 480,
            sizes: [
              { size: 165, screen: 375 },
              { size: 230, screen: 500 },
              { size: 240, screen: 750 },
              { size: 315, screen: 1000 },
              { size: 350, screen: 1350 },
              { size: 424, screen: 1650 },
              { size: 480, screen: 2000 }
            ],
            class:`${CP}__image ${CP}__image-top`
          }).replace('<img', '<img loading="lazy"')}

          <div class="o-product-thumbnail__badge-container">
            ${badges.reduce((x,name) => {
              if (name.toLowerCase() === 'new' && isPreorder) return x;
              if (name.toLowerCase() === 'waitlist') return x;
              if (name.toLowerCase() === 'sale') {
                return x += `<span class="o-product-thumbnail__badge is-sale">${name}</span>`;
              } else {
                return x += `<span class="o-product-thumbnail__badge">${name}</span>`;
              }
            }, '')}
            ${isPreorder?`<span class="o-product-thumbnail__badge">${Language.strings['products.product.preorder_badge']}</span>`:''}
          </div>
        </a>

        <div class="${CP}__add-container">
          <div class="${CP}__swatch-price-container">
            <div class="${CP}__swatch" data-product-swatch-selector>
              ${shouldPrintSwatch ?
                showVariants && p.variants.length > 1 ? getSwatchHTML(p, v) : printMoney(v.price)
              : printMoney(v.price)
              }
            </div>
          </div>


          <button data-product-thumbnail-add-to-cart-button type="button"
            ${disabled?'disabled="true"':''}
            class="o-btn ${CP}__add-button  ${disabled?'is-disabled':''}"
          >
            <span>Quick Add</span>
          </button>
        </div>
      </div>

      <div class="${CP}__details">
        <div class="${CP}__details-wrapper">
          <a href="${url}">
            <span itemprop="name" class="${CP}__title">
              ${p.title}
            </span>
          </a>

          <button class="${CP}__wishlist" data-product-template-wishlist role="button" title="add to wish list" ${generateWishlistAttr(p,v)}>
            ${generateIcon('heart-grey', 'o-product-thumbnail__wishlist-icon')}
            ${generateIcon('heart--full-grey', 'o-product-thumbnail__wishlist-icon is-full')}
          </button>
        </div>

        <div class="${CP}__price-container" data-product-thumbnail-price>
          ${(discounted) ? `
            <span class="${CP}__price-compare-original"
              data-currency
              data-money="${compare}"
              data-product-compare-money
            >
              ${printMoney(compare)}
            </span>

            ${productsShowPercentageOff ? `
              <span class="${CP}__price-compare-saving">
                ${Math.floor(saving)}% ${t('products.product.off')}
              </span>
            `: ''}`
          : '' }

          <span class="${CP}__price" data-currency data-product-money data-money="${v.price}">
            ${printMoney(v.price)}
          </span>
        </div>

        <div class="o-product-thumbnail__waitlist-message">
          ${v.waitlist_eta && isPreorder ? `${Language.strings['products.product.waitlist_message']} ${v.waitlist_eta}`: ``}
        </div>

        ${yotpoReviews !== undefined && yotpoReviews !== false ? 
          `<a href="${p.url}#reviews" class="o-product-thumbnail__yotpo-reviews">
            ${yotpoReviews}
          </a>` : ``
        }
                

        ${hasColourOption && !showVariants?
          `<div class="${CP}__swatch show-watch">
            ${getSwatchHTML(p, v)}
          </div>` : ''}

        ${discountContainer.innerHTML.length ? discountContainer.outerHTML : ''}
      </div>
    </div>
  </div>
  `
};

//${available ? Language.strings['products.product.add_to_cart'] : Language.strings['products.product.sold_out']}
export const generateWishlistAttr = (p,v) => {
  return `
  data-wishlist-epi="${v.id}"
  data-wishlist-empi="${p.id}"
  data-wishlist-iu="${p.image+''.toString().replace(/^http(s)?:/, '')}"
  data-wishlist-pr="${p.price}"
  data-wishlist-stk="${v.inventory_quantity}"
  data-wishlist-du="${location.protocol}//${location.hostname}${p.url}"
  data-wishlist-dt="${p.title}" `;
}

export const generateProductSchema = (p) => {
  const escapedDescription = (p.description.replace(/(<([^>]+)>)/gi, "").replace(/’/g, "&#39;"));

  const printv = (p) => {
    let html = '';
    let v = p.variants;

    const gtin = v.reduce((x, y) => {
      if(!y.barcode) return x;
      if(y.barcode.length >= 12 && y.barcode.length <= 14) {
        return `"gtin${y.barcode.length}" : "${y.barcode}",`;
      }
    },'');

    for (let index = 0; index < v.length; index++) {
      const todaysDate = new Date().toLocaleDateString('en-GB');
      if (index > 0 ) html += ',';
      html += `{
        "@type" : "Offer",
        "availability" : "${p.available?'InStock':'OutOfStock'}",
        "price" : "${v[index].price / 100}",
        "priceValidUntil" : "${todaysDate}",
        "priceCurrency" : "${p.currency}",
        "url" : "${location.protocol}//${location.hostname}${p.url}",
        ${gtin ? gtin : ''}
        "itemOffered" :{
            "@type" : "Product",
            "image": "${v[index].featured_image && v[index].featured_image.src ? v[index].featured_image.src:''}",
            "name" : "${v[index].title}",
            "url" : "${location.protocol}//${location.hostname}${p.url}?variant=${v[index].id}",
            "sku": "${v[index].sku}",
            "description": "${escapedDescription}",
            "brand": {
              "@type": "Brand",
              "name": "${p.vendor}"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "${p.ratingValue}",
              "ratingCount": "${p.ratingCount}"
            }
          }
        }`;
    }
    return html;
  }
  return `{
      "@context": "http://schema.org/",
      "@type": "Product",
      "name": "${p.title}",
      "url": "${location.protocol}//${location.hostname}${p.url}",
      "image":"${location.protocol}${p.image}",
      "description": "${escapedDescription}",
      "brand": {
        "@type": "Brand",
        "name": "${p.vendor}"
      },
      "offers": [
        ${printv(p)}
      ]
    }`;
}